var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"description",staticClass:"ellipsis-content",class:_vm.ellipsisContentVisible ? 'ellipsis' : ''},[_c('div',[_vm._v("\n    "+_vm._s(_vm.keyword)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }